import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

async function create(data) {
  const response = await http
    .postData("/catatan-harian-bbl", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function update(id: number, data) {
  const response = await http
    .putData(`/catatan-harian-bbl/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function find(id: number) {
  const response = await http
    .getData(`/catatan-harian-bbl/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/catatan-harian-bbl/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getByRegister(registerId: string | number) {
  const response = await http
    .getData(`/register/${registerId}/catatan-harian-bbl`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getByDate(registerId: string | number, tanggal: string) {
  const response = await http
    .getData(`/register/${registerId}/catatan-harian-bbl/tanggal/${tanggal}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function carryForward(registerId: string | number, data) {
  const response = await http
    .postData(`/register/${registerId}/catatan-harian-bbl/carry-forward`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function verifyDpjp(id: number) {
  const response = await http
    .postData(`/catatan-harian-bbl/${id}/verify-dpjp`, {})
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function storeObservasi(catatanId: number, data) {
  const response = await http
    .postData(`/catatan-harian-bbl/${catatanId}/observasi`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function updateObservasi(obsId: number, data) {
  const response = await http
    .putData(`/catatan-harian-bbl-observasi/${obsId}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function deleteObservasi(obsId: number) {
  const response = await http
    .deleteData(`/catatan-harian-bbl-observasi/${obsId}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

function printPdf(id: number) {
  window.open(
    `${http.getAPI()}/catatan-harian-bbl/${id}/pdf`,
    "_blank"
  );
}

export default {
  create,
  update,
  find,
  destroy,
  getByRegister,
  getByDate,
  carryForward,
  verifyDpjp,
  storeObservasi,
  updateObservasi,
  deleteObservasi,
  printPdf
};
